<template>
  <el-drawer
    class="sideDrawer"
    destroy-on-close
    :size="drawerSize"
    title="编辑套餐"
    :visible="dialogVisible"
    :before-close="beforeClose"
    append-to-body
    :wrapperClosable="false"
    :close-on-press-escape="false"
    ><i class="iconfont icon-back-quanping iconFull" @click="drawerSize = '100%'" v-if="drawerSize == '70%'" />
    <i @click="drawerSize = '70%'" class="iconfont icon-back-tuichuquanping iconFull" v-else />
    <el-form style="padding: 20px" ref="form" :model="tempValue" label-width="100px" :rules="rules" :inline="true">
      <el-row>
        <el-col :span="12">
          <el-form-item label="套餐名称:" prop="combo_name">
            <eco-input v-model="tempValue.combo_name" style="width: 100%" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="收费类型:" prop="charge_type">
            <el-select style="width: 100%" v-model="tempValue.charge_type" @change="chargeTypeChange">
              <el-option v-for="item in boDefIdList" :key="item.id" :value="item.key" :label="item.name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="年:" prop="year" v-if="rules.year">
            <el-input-number v-model="tempValue.year" :precision="1" style="width: 100%" :step="0.1" step-strictly></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="用户数:" prop="user_num" v-if="rules.user_num">
            <el-input-number v-model="tempValue.user_num" style="width: 100%" :step="1" step-strictly></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="次数:" prop="times" v-if="rules.times">
            <el-input-number style="width: 100%" v-model="tempValue.times" :step="1" step-strictly></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="套餐价格:" prop="price">
            <el-input-number v-model="tempValue.price" :min="0" :precision="2" style="width: 100%" :step="0.1"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="关联产品:" prop="relation">
            <el-select multiple style="width: 100%" v-model="tempValue.relation">
              <el-option v-for="item in purposeList" :key="item.account_module" :value="item.account_module" :label="item.account_name"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="编制人:" prop="create_user">
            <eco-input style="width: 100%" disabled v-model="tempValue.create_user" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="编制时间:" prop="create_time">
            <eco-input style="width: 100%" disabled v-model="tempValue.create_time" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="demo-drawer__footer">
      <el-button @click="beforeClose" size="small">取消</el-button>
      <el-button size="small" @click="submit('form')" type="primary" :loading="tempAddLoading">确定</el-button>
    </div>
  </el-drawer>
</template>

<script>
import form from '@/api/form'
import * as constants from './constants'
import { mapState } from 'vuex'
export default {
  name: 'tempAdd',
  props: {
    selectModel: {
      type: String,
      default: () => ''
    },
    dialogVisible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      drawerSize: '70%',
      tempValue: {
        combo_name: '',
        charge_type: '',
        year: '',
        user_num: '',
        times: '',
        price: '',
        sub_third_combo_account_relation: [],
        relation: []
      },
      boDefIdList: [],
      formKeyList: [],
      purposeList: [],
      fileList: [],
      tempAddLoading: false,
      pageBean: {
        page: 1,
        pageSize: 999,
        total: 0
      },
      rules: {
        combo_name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        charge_type: [{ required: true, message: '请选择收费类型', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
      },
      selectUploadId: '',
      ...constants
    }
  },
  watch: {
    selectModel(newVal) {
      if (newVal) {
        this.getDetailThirdCombo()
      }
    }
  },
  computed: {
    ...mapState({
      currentUserDetail: (state) => state.user.currentUserDetail
    })
  },
  mounted() {
    // 根据id获取数据
    this.getDetailThirdCombo()
    this.getSflxTree()
  },
  methods: {
    getDetailThirdCombo() {
      if (!this.selectModel) return false
      let params = {
        id: this.selectModel
      }
      form.getDetailThirdCombo(params).then((res) => {
        this.chargeTypeChange(res.charge_type, res)
      })
    },
    chargeTypeChange(e, b) {
      let rules = {
        combo_name: [{ required: true, message: '请输入套餐名称', trigger: 'blur' }],
        charge_type: [{ required: true, message: '请选择收费类型', trigger: 'blur' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
      }
      let temp = this.boDefIdList.find((item) => item.key === e)
      if (temp.children) {
        temp.children.forEach((items) => {
          if (items.name === '用户数') {
            rules['user_num'] = [{ required: true, message: '请输入用户数', trigger: 'blur' }]
          }
          if (items.name === '年数') {
            rules['year'] = [{ required: true, message: '请输入年', trigger: 'blur' }]
          }
          if (items.name === '次数') {
            rules['times'] = [{ required: true, message: '请输入次数', trigger: 'blur' }]
          }
        })
      }
      // if (e)
      let params = {
        chargeType: e
      }
      form.getRelateProductByChargeType(params).then((res) => {
        this.purposeList = res
        if (b) {
          this.tempValue.id = b.id
          this.tempValue.charge_type = b.charge_type
          this.tempValue.combo_name = b.combo_name
          this.tempValue.year = b.year
          this.tempValue.user_num = b.user_num
          this.tempValue.times = b.times
          this.tempValue.price = b.price
          this.tempValue.create_user = b.create_user
          this.tempValue.createBy = b.createBy
          this.tempValue.create_time = b.create_time
          let temp = []
          b.sub_third_combo_account_relation.forEach((item) => {
            temp.push(item.account_module)
          })
          this.tempValue.relation = temp
        } else {
          this.tempValue.relation = []
          this.tempValue.sub_third_combo_account_relation = []
        }
        this.rules = rules
      })
    },
    // 获取收费类型树结构
    getSflxTree() {
      let params = {
        typeKey: 'sflx'
      }
      form.getByTypeKeyForComBo(params).then((resp) => {
        this.boDefIdList = resp
      })
    },
    beforeClose() {
      this.$emit('beforeClose')
      this.tempValue = {
        combo_name: '',
        charge_type: '',
        year: '',
        user_num: '',
        times: '',
        price: '',
        sub_third_combo_account_relation: [],
        relation: []
      }
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        this.tempAddLoading = true
        if (valid) {
          let params = Object.assign({}, this.tempValue)
          params['sub_third_combo_account_relation'] = []
          if (this.tempValue.relation && this.tempValue.relation.length > 0) {
            this.purposeList.forEach((item) => {
              this.tempValue.relation.forEach((items) => {
                if (item.account_module === items) {
                  params['sub_third_combo_account_relation'].push(item)
                }
              })
            })
          }
          form
            .getUpdateThirdCombo(params)
            .then((resp) => {
              if (resp.state) {
                this.$message.success('更新完成')
              }
              this.tempAddLoading = false
              this.beforeClose()
            })
            .catch(() => {
              this.tempAddLoading = false
            })
        } else {
          this.tempAddLoading = false
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
/deep/.el-form-item {
  width: 100%;
}
/deep/.el-form-item__content {
  width: calc(100% - 100px);
}
</style>
